module.exports = __webpack_public_path__ + "static/img/5-2.1561cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/5-2.png
// module id = m0KL
// module chunks = 1